import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Button } from 'reactstrap';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import ActividadesList from './ActividadesList';

const Actividades = () => {
	const { inspectionId } = useParams();
	const navigate = useNavigate();

	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Normativa', icon: 'icon-leaf' },
		{ to: '/fiscalizacion/fiscalizaciones', label: 'Fiscalización', icon: 'icon-clipboard-check' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<div className='d-flex flex-column mb-2'>
						<BreadCrumb
							title='Actividades (Incumplimientos)'
							links={breadcrumbLinks}
							icon={'icon-list-checks'}
						/>
						<Button
                            color='primary'
                            size='sm'
							className='btn-label align-self-start'
							onClick={() => navigate('/fiscalizacion/fiscalizaciones')}
						>
							<i className='ri-arrow-left-line label-icon' style={{ fontSize: '0.875rem' }}></i>
							Volver
						</Button>
					</div>
					<ActividadesList inspectionId={inspectionId} />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Actividades;
